module.exports = __webpack_public_path__ + "page-92d620f2/premium-seats-4f2e178a799ff2aa41aa55cdb3ba1b03.webp";